import { render } from "./ModalSheetHandle.vue?vue&type=template&id=048b2f77&scoped=true&lang=pug"
import script from "./ModalSheetHandle.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSheetHandle.vue?vue&type=script&setup=true&lang=js"

import "./ModalSheetHandle.vue?vue&type=style&index=0&id=048b2f77&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048b2f77"]])

export default __exports__